export interface CmmdTaskGoalInput {
  readonly projectId: string | number;
  readonly taskId: string | number;
  readonly title: string;
  readonly description?: string | null;
  readonly updatedAt?: string | null;
}

const DEFAULT_TASK_DESCRIPTION =
  "Complete the task according to its current CMMD acceptance criteria.";
const TASK_GOAL_MAX_LENGTH = 500;

export function buildCmmdTaskGoal(input: CmmdTaskGoalInput): string {
  const taskId = String(input.taskId).trim();
  const projectId = String(input.projectId).trim();
  const title = input.title.trim();
  const description = input.description?.trim() || DEFAULT_TASK_DESCRIPTION;
  const revision = input.updatedAt?.trim() || "unavailable";

  const goal = `CMMD Project #${projectId} · Task #${taskId}: ${title}\nTask revision: ${revision}\n\n${description}`;
  if (goal.length <= TASK_GOAL_MAX_LENGTH) return goal;
  return `${goal.slice(0, TASK_GOAL_MAX_LENGTH - 1).trimEnd()}…`;
}
